var _desc, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVetrahubLogoCandidateDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VetraHub") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "VetraHub logo \u2014 dark background, candidate version")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-0.8) scale(0.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6,
    width: 70,
    height: 70,
    rx: 13,
    fill: "#0025D8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 24,
    x2: 35,
    y2: 61,
    stroke: "rgba(255,255,255,0.48)",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 24,
    x2: 35,
    y2: 61,
    stroke: "rgba(255,255,255,0.48)",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 61,
    x2: 59,
    y2: 51,
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 61,
    x2: 11,
    y2: 51,
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 24,
    x2: 11,
    y2: 51,
    stroke: "rgba(255,255,255,0.12)",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 24,
    x2: 59,
    y2: 51,
    stroke: "rgba(255,255,255,0.12)",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 24,
    r: 5.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 24,
    r: 5.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 61,
    r: 6.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 51,
    r: 3.5,
    fill: "rgba(255,255,255,0.62)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 51,
    r: 3.5,
    fill: "rgba(255,255,255,0.62)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 37,
    fontFamily: "'Cabinet Grotesk','IBM Plex Sans',-apple-system,sans-serif",
    fontSize: 36
  }, /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 700,
    fill: "#FAFAFA"
  }, "vetra"), /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 700,
    fill: "#7B9EFF"
  }, "hub"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 54,
    fontFamily: "'IBM Plex Sans',-apple-system,sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.09em",
    fill: "rgba(250,250,250,0.55)"
  }, "PRACTICE SMARTER. LAND THE OFFER.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetrahubLogoCandidateDark);
export default __webpack_public_path__ + "static/media/vetrahub-logo-candidate-dark.68b31077d6515918e84dcccce3195e56.svg";
export { ForwardRef as ReactComponent };